import { Container, Col, Row } from "reactstrap";
import { BreadcrumbItem } from "reactstrap";
import * as EntryQL from "queries/entry";
import * as Notify from "@repoflow/form-schema/notify";
import { CancellableContent } from "@repoflow/components/content-cancel";
import {
  Mutation,
  Button,
  useSectionContext,
} from "@repoflow/components/section";

export const Sidebar = () => null;

export const Indice = () => (
  <>
    <BreadcrumbItem>Remove</BreadcrumbItem>
  </>
);

export const Content = ({ history, match: { params } }) => {
  const { values } = useSectionContext();
  const date = values?.date;

  return (
    <CancellableContent>
      <Row>
        <Col>
          Remove <b>{values?.food || params.entryId}</b> from {date || "this day"}?
          This can't be undone.
        </Col>
      </Row>
      <Mutation
        mutation={EntryQL.remove}
        update={EntryQL.update()}
        onMutate={({ handler }) => {
          handler({
            variables: { entryId: params.entryId },
          });
        }}
        onCompleted={() => {
          history.replace(date ? `/day/${date}` : `/day`);
        }}
        onError={(error) => {
          Notify.error(error.toString());
        }}
      >
        {MutationHandler}
      </Mutation>
    </CancellableContent>
  );
};

const MutationHandler = ({ mutate }) => {
  return (
    <Container className="mt-4">
      <Row>
        <Col>
          <Button
            onClick={() => {
              mutate();
            }}
          >
            Remove
          </Button>
        </Col>
      </Row>
    </Container>
  );
};
